import { useSelector } from 'react-redux';
import { VolumeSettings, channelGain } from './volumeSettings';
import { selectVolumeSettings } from './volumeSlice';

/** The narration channel's current gain (0 to 1), for a video element's volume. */
export function useNarrationGain(): number {
  return useSelector((state: { volumeReducer?: VolumeSettings }) =>
    channelGain(selectVolumeSettings(state), 'narration'),
  );
}
